import React from "react";
import { Grid, Typography } from "@mui/material";
import { useStyles } from "./styles";
import { Container } from "@mui/system";
import Logo from "../../assets/images/Login/logo.svg";
import LOGO from "../../assets/images/Sidebar/logo.svg";

const PrivacyPolicy = () => {
  const classes = useStyles();
  return (
    <Container xs={12} className={classes.root}>
      <Grid sx={{ display: "flex" }}>
        <Grid>
          <img
            style={{ width: "55%", padding: "20px" }}
            src={Logo}
            alt="College Connect"
          />
        </Grid>
        <Grid>
          {" "}
          <Typography
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "50px",
              fontSize: "40px",
              fontWeight: 700,
              color: "#25D5A1",
              cursor: "pointer",
            }}
          >
            Privacy Policy
          </Typography>
        </Grid>
      </Grid>
      <Grid px={8}>
        {" "}
        <Typography sx={{ color: "#25D5A1" }}>
          Welcome to College Connect Privacy Policy!
        </Typography>
        <Typography mt={3}>
          Your privacy is important to us. It is Hubino Technologies Private Limited's policy to respect your privacy regarding any information we may
          collect from you across our website,{" "}
          <a href="https://collegeconnect.cyou.co" style={{ color: "#25D5A1" }}>
            https://collegeconnect.cyou.co
          </a>
          , and other sites we own and operate.
        </Typography>
        <Typography mt={3}>
          We only ask for personal information when we truly need it to provide
          a service to you. We collect it by fair and lawful means, with your
          knowledge and consent. We also let you know why we’re collecting it
          and how it will be used.
        </Typography>
        <Typography mt={3}>
          We only retain collected information for as long as necessary to
          provide you with your requested service. What data we store, we’ll
          protect within commercially acceptable means to prevent loss and
          theft, as well as unauthorised access, disclosure, copying, use or
          modification.
        </Typography>
        <Typography mt={3}>
          We don’t share any personally identifying information publicly or with
          third-parties, except when required to by law.
        </Typography>
        <Typography mt={3}>
          Our website may link to external sites that are not operated by us.
          Please be aware that we have no control over the content and practices
          of these sites, and cannot accept responsibility or liability for
          their respective privacy policies.
        </Typography>
      </Grid>
      {/* <Grid px={9} lineHeight={2} sx={{ color: "#25D5A1" }}>
        <ui>
          <li> DEFINITIONS</li>
          <li>DATA CONTROLLER OR DATA PROCESSOR</li>
          <li>WHAT DATA DO WE COLLECT ABOUT YOU AND WHEN?</li>
          <li>PERSONAL DATA WE PROCESS</li>
          <li>WHAT WE DO NOT DO?</li>
          <li>PERSONAL DATA SECURITY</li>
          <li>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</li>
          <li>INTERNATIONAL TRANSFER OF YOUR PERSONAL DATA</li>
          <li>HOW LONG DO WE KEEP YOUR DATA?</li>
          <li>YOUR RIGHTS</li>
          <li>CALIFORNIA RESIDENTS PRIVACY NOTICE</li>
          <li>CHANGES TO PRIVACY POLICY</li>
        </ui>
      </Grid> */}
      <Grid px={8} mt={4}>
        {/* <Typography
          sx={{ fontWeight: "600", fontSize: "18px", color: "#25D5A1" }}
        >
          1. DEFINITIONS
        </Typography> */}
        <Typography mt={3}>
          You are free to refuse our request for your personal information, with
          the understanding that we may be unable to provide you with some of
          your desired services.
        </Typography>
        <Typography mt={3}>
          Your continued use of our website will be regarded as acceptance of
          our practices around privacy and personal information. If you have any
          questions about how we handle user data and personal information, feel
          free to contact us.
        </Typography>
        {/* <Typography mt={3}>
          When we say "Data Processors" or "processor" we mean any natural or
          legal person who processes the data on behalf of the Data Controller.
          In some cases, COING is a Data Processor and in others, Data
          Controller (as further explained in Section 2). In addition, we may
          use the services of various service providers to process your data
          more effectively. In such cases, they are either our processors or
          sub-processors.
        </Typography>
        <Typography mt={3}>
          When we say "cookies" we mean small pieces of data stored on your
          device (computer or mobile device). This information is used to track
          your use of the Website and to compile reports on website activity.
          For further information about the use of cookies and how you can
          manage them, please read our Cookie Policy.
        </Typography>
        <Typography mt={3}>
          When we say "consent" we mean your explicit consent on the processing
          of personal data. Persons who are 15 years of age or older may give
          free consent to the processing of their personal data. However, the
          User of CollegeConnect has to be of age of majority as defined in
          Terms of Use.
        </Typography>
      //
      <Grid px={8} mt={4}>
        <Typography
          sx={{ fontWeight: "600", fontSize: "18px", color: "#25D5A1" }}
        >
          2. DATA CONTROLLER OR DATA PROCESSOR
        </Typography>
        <Typography mt={3}>
          In relation to your personal data processed on or via the Website and
          the Service, COING may be either a Data Controller or Data Processor.
        </Typography>
        <Typography mt={3}>
          When COING acts in the capacity of a Data Controller, COING determines
          the purposes and the essential means of the processing of personal
          data. The purpose of data processing is the reason why we process your
          personal data. The table in Section 4.1 of the Privacy Policy presents
          the purposes and legal basis for data processing. In such cases, COING
          is responsible for your personal data.
        </Typography>
        <Typography mt={3}>
          By using the Service, you may disclose, share, record, or otherwise
          use various types of data via a Workspace as the User Content. The
          type of User Content is determined by the person that owns the
          Workspace and not by us. The extent to which personal data is
          processed while using the Service also depends on the CollegeConnect
          functionalities that the owner of the Workspace decides to use. In
          that event, COING is a Data Processor and Data Controller is the owner
          of the Workspace. Thus, COING does not analyze, disclose or access
          such data unless a User (including an Enterprise as a User) sends a
          request for support and, in these cases, the access is limited to
          enabling the functioning of the Service.
        </Typography>
        <Typography mt={3}>
          Given that COING strongly supports the principle of transparency of
          personal data processing, despite being a Data Processor, COING made
          an additional effort to explain personal data processing via the
          Service in Section 4.2 of this Privacy Policy. The information
          contained therein outlines how personal data processing via
          CollegeConnect functions in general. Nevertheless, should you wish to
          send an inquiry or exercise any of your Data Subject's rights which
          you may have under the applicable data protection legislation to the
          owner of the Workspace, please contact such owner of the relevant
          Workspace as Data Controller.
        </Typography>
        <Typography mt={3}>
          Please also note that we do not collect or process your personal data
          if you are an End User of Server CollegeConnect. In that case, Client
          (the company that has CollegeConnect installed on their server) is
          responsible for your personal data.
        </Typography>
        <Typography mt={3}>
          If you represent a User that falls under the scope of application of
          the GDPR or similar data protection legislation, you may sign the Data
          Protection Addendum to these Terms of Use ("DPA"), with COING as a
          Data Processor based outside the EEA. The DPA includes the Standard
          Contractual Clauses adopted by the European Commission, as applicable,
          and reflects the Parties' agreement with respect to the terms
          governing the processing of personal data under the CollegeConnect's
          Terms of Use. Signing the DPA will be considered as an amendment to
          the Agreement (within the meaning of Section 1 of the Terms of Use)
          and will be considered to form a part of the Agreement.
        </Typography>
      </Grid>
      <Grid px={8} mt={4}>
        <Typography
          sx={{ fontWeight: "600", fontSize: "18px", color: "#25D5A1" }}
        >
          3. WHAT DATA DO WE COLLECT ABOUT YOU AND WHEN?
        </Typography>
        <Typography mt={3}>
          We may collect and receive information about you in various ways:
        </Typography>
        <Typography mt={3}>
          (i) Information you provide through the use of the Service (for
          example, by creating the account on Cloud CollegeConnect).
        </Typography>
        <Typography mt={3}>
          (ii) Information you decide to provide through getting in touch with
          us via support@CollegeConnect.me.
        </Typography>
        <Typography mt={3}>
          (iii) Information we collect through the use of cookies or similar
          technologies in accordance with our Cookie Policy (for example, your
          time zone).
        </Typography>
      </Grid>
      <Grid px={8} mt={4}>
        <Typography
          sx={{ fontWeight: "600", fontSize: "18px", color: "#25D5A1" }}
        >
          4. PERSONAL DATA WE PROCESS
        </Typography>
        <Typography mt={3}>
          As previously stated, concerning your personal data processed on or
          via the Service, COING is a Data Processor and the Owner of the
          Workspace is the Data Controller. COING processes personal data
          following instructions from the Data Controller and under the Terms of
          Use and DPA (if any). The purpose of such personal data processing is
          productivity management during work hours of the team where the Owner
          of the Workspace may get an accurate report of the workweek, improve
          project profitability, compile reports for the clients, track
          attendance of employees and/or other team members and track their
          work.
        </Typography>
        <Typography mt={3}>
          As a processor, COING is permitted to collect, use, disclose and/or
          otherwise process your personal data only following the instructions
          of the Owner of the Workspace.
        </Typography>
        <Typography mt={3}>
          If you have any questions regarding the legal basis for such personal
          data processing, please contact the Owner of the Workspace who invited
          you to the Service.
        </Typography>
      </Grid>
      <Grid px={8} mt={4}>
        <Typography
          sx={{ fontWeight: "600", fontSize: "18px", color: "#25D5A1" }}
        >
          5. PERSONAL DATA SECURITY
        </Typography>
        <Typography mt={3}>
          If you decide to accept the invitation to use the Service, you will be
          required to create an account. To create the User Account, you will
          need to share your email address and password.
        </Typography>
        <Typography mt={3}>
          In the course of the use of the Service we may process system usage
          data, IP address, work position, attendance at work, time-tracking
          data you inserted (for example, the time you started work, the time
          you finished work, tasks or projects worked on), application
          integration data, navigational data (including website usage
          information such as interactions with CollegeConnect, and other
          electronic data submitted, stored, sent, or received by the Data
          Controller via the Service.
        </Typography>
        <Typography mt={3}>
          If you choose to connect your CollegeConnect account to Google
          Calendar or Outlook (Office 365), you will be able to track time for
          events right from such calendars. This function enables a User to have
          the events from the calendar within the CollegeConnect calendar and
          create time entries for each event, as further explained here. Once
          the calendar is connected, you will see all events from Google
          Calendar or Outlook right inside CollegeConnect. If you make changes
          in the external calendar, those changes will reflect in
          CollegeConnect.
        </Typography>
      </Grid> */}
      </Grid>
      <Grid
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: "30px",
          alignItems: "center",
          color: "#25D5A1",
        }}
      >
        <img src={LOGO} alt="logo" />

        <Typography sx={{
          fontSize:'13px',
        }}>
          ©{new Date().getFullYear()} HUBINO TECHNOLOGIES PRIVATE LIMITED. All Rights Reserved.</Typography>
        {/* <Typography>Terms of Service</Typography>
        <Typography>Privacy Policy</Typography>
        <Typography>Security Policy</Typography>
        <Typography>GDPR Compliance</Typography> */}
      </Grid>
    </Container>
  );
};

export default PrivacyPolicy;
